import "jquery";
import { ApiResultCodes } from "../enum/ApiResultCodes";
import * as Utility from "../commons/Utility";
/**
 * POST
 *
 * @param url URL
 * @param data 送信データ
 * @param fn 成功時のイベント
 */

export function Post(url, data, fn) {
  $.ajax({
    type: "POST",
    cache: false,
    url: url,
    data: data,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'RequestVerificationToken': String($("#RequestValificationToken").val())
    },
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    dataType: "text",
    success: function success(data) {
      if (redirectPage(data)) {
        return;
      }

      try {
        fn(data);
      } catch (_unused) {
        redirectError();
      }
    },
    error: function error(data) {
      console.log(data.status + ":" + data.statusText);
      writingConsoleAjaxError(data.responseText);
      redirectError();
    }
  });
}
/**
 * イメージ取得
 *
 * @param url URL
 * @param data 送信データ
 * @param fn 成功時のイベント
 */

export function Image(url, data, i, j, fn) {
  data.append(window.Settings.RvtKey, String($("#RequestValificationToken").val()));
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('contentType', 'application/x-www-form-urlencoded; charset=utf-8');
  xhr.setRequestHeader('RequestVerificationToken', String($("#RequestValificationToken").val()));
  xhr.responseType = 'blob';

  xhr.onload = function () {
    if (xhr.status == 200) {
      fn(i, j, xhr.response);
    } else {
      console.log(xhr.status.toString());
      writingConsoleAjaxError(xhr.status.toString());
    }
  };

  xhr.onerror = function () {
    console.log(xhr.status.toString());
    writingConsoleAjaxError(xhr.status.toString());
  };

  xhr.send(data);
}
/**
 * イメージ取得
 *
 * @param url URL
 * @param data 送信データ
 * @param fn 成功時のイベント
 */

export function SceneImage(url, data, i, j, type, fn) {
  data.append(window.Settings.RvtKey, String($("#RequestValificationToken").val()));
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('contentType', 'application/x-www-form-urlencoded; charset=utf-8');
  xhr.setRequestHeader('RequestVerificationToken', String($("#RequestValificationToken").val()));
  xhr.responseType = 'blob';

  xhr.onload = function () {
    if (xhr.status == 200) {
      fn(i, j, type, xhr.response);
    } else {
      console.log(xhr.status.toString());
      writingConsoleAjaxError(xhr.status.toString());
    }
  };

  xhr.onerror = function () {
    console.log(xhr.status.toString());
    writingConsoleAjaxError(xhr.status.toString());
  };

  xhr.send(data);
  return xhr;
}
/**
 * ダウンロード
 *
 * @param url URL
 * @param data 送信データ
 * @param fn 成功時のイベント
 */

export function Download(url, data, fn) {
  setTimeout(function () {
    $("#overlay").fadeIn();
  });
  data.append(window.Settings.RvtKey, String($("#RequestValificationToken").val()));
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('contentType', 'application/x-www-form-urlencoded; charset=utf-8');
  xhr.setRequestHeader('RequestVerificationToken', String($("#RequestValificationToken").val()));
  xhr.responseType = 'blob';

  xhr.onload = function () {
    setTimeout(function () {
      $("#overlay").fadeOut(300);
    }, 500);

    if (xhr.status == 200) {
      fn(xhr.response);
    } else {
      console.log(xhr.status.toString());
      writingConsoleAjaxError(xhr.status.toString());
      redirectError();
    }
  };

  xhr.onerror = function () {
    setTimeout(function () {
      $("#overlay").fadeOut(300);
    }, 500);
    console.log(xhr.status.toString());
    writingConsoleAjaxError(xhr.status.toString());
    redirectError();
  };

  xhr.send(data);
}
/**
 * アップロード
 *
 * @param url URL
 * @param data 送信データ
 * @param fn 成功時のイベント
 */

export function Upload(url, data, fn) {
  setTimeout(function () {
    $("#overlay").fadeIn();
  });
  data.append(window.Settings.RvtKey, String($("#RequestValificationToken").val()));
  $.ajax({
    type: "POST",
    cache: false,
    url: url,
    data: data,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'contentType': 'application/x-www-form-urlencoded; charset=utf-8',
      'RequestVerificationToken': String($("#RequestValificationToken").val())
    },
    contentType: false,
    processData: false,
    dataType: "text",
    success: function success(data) {
      setTimeout(function () {
        $("#overlay").fadeOut(300);
      }, 500);

      if (redirectPage(data)) {
        return;
      }

      fn(data);
    },
    error: function error(data) {
      setTimeout(function () {
        $("#overlay").fadeOut(300);
      }, 500);
      console.log(data.status + ":" + data.statusText);
      writingConsoleAjaxError(data.responseText);
      redirectError();
    }
  });
}
/**
 * アップロード（サイレントモード）
 *
 * @param url URL
 * @param data 送信データ
 * @param fn 成功時のイベント
 */

export function SilentUpload(url, data, fn) {
  data.append(window.Settings.RvtKey, String($("#RequestValificationToken").val()));
  $.ajax({
    type: "POST",
    cache: false,
    url: url,
    data: data,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'contentType': 'application/x-www-form-urlencoded; charset=utf-8',
      'RequestVerificationToken': String($("#RequestValificationToken").val())
    },
    contentType: false,
    processData: false,
    dataType: "text",
    success: function success(data) {
      if (redirectPage(data)) {
        return;
      }

      fn(data);
    },
    error: function error(data) {
      console.log(data.status + ":" + data.statusText);
      writingConsoleAjaxError(data.responseText);
      redirectError();
    }
  });
}
/**
 * コンソールにajaxエラーを書き込みます。
 *
 * @param text テキスト
 */

function writingConsoleAjaxError(text) {
  var msgs = text.split(/\r\n|\r|\n/);

  for (var i = 0; i < msgs.length; i++) {
    if ($.trim(msgs[i]) != '') {
      console.log(msgs[i]);
    }
  }
}
/**
 * 結果として戻された画面にリダイレクトします。
 *
 * @param html HTML
 */


function redirectPage(html) {
  if (html.indexOf("<!DOCTYPE html>") >= 0) {
    writingConsoleAjaxError(html);
    var target = false;
    [{
      id: "Login",
      url: "/Timeout.html"
    }, {
      id: "Login_SmartPhone",
      url: "/Timeout.html"
    }, {
      id: "PageNotFound",
      url: "/PageNotFound.html"
    }, {
      id: "Timeout",
      url: "/Timeout.html"
    }, {
      id: "Error",
      url: "/Error.html"
    }].forEach(function (x) {
      var page = '<html id="' + x.id + '">';

      if (html.indexOf(page) >= 0) {
        window.location.href = x.url;
        target = true;
      }
    });

    if (!target) {
      redirectError();
    }

    return true;
  } else {
    return false;
  }
}
/**
 * エラー画面にリダイレクトします。
 */


function redirectError() {
  window.location.href = "/Error.html";
}
/**
 * 結果をモデルに変換して戻します。
 *
 * @param fn ファンクション
 */


export function ModelResult(fn) {
  return function (data) {
    var model = JSON.parse(data, function (key, val) {
      switch (key) {
        //XXX date変換
        case "StartDateTime":
        case "EndDateTime":
        case "LastModified":
        case "ReductionRequestDateTime":
        case "ReductionCompleteDateTime":
          return val == null ? null : Utility.ToMoment(val).toDate();

        default:
          return val;
      }
    });

    switch (model.ResultCode) {
      case ApiResultCodes.Success:
        break;

      case ApiResultCodes.UpdateDateRetrieved:
        if (model.ResultMessage === undefined || model.ResultMessage === null) alert("他で更新されています。画面を最新化しますので、再度やり直してください。");else alert(model.ResultMessage);
        break;

      case ApiResultCodes.UniqueIndexViolation:
        if (model.ResultMessage === undefined || model.ResultMessage === null) alert("他のデータと重複しています。");else alert(model.ResultMessage);
        break;

      case ApiResultCodes.AlreadyRegistered:
        alert(model.ResultMessage);
        break;

      case ApiResultCodes.UsersExceeded:
        alert(model.ResultMessage);
        break;

      case ApiResultCodes.GuestsExceeded:
        alert(model.ResultMessage);
        break;

      case ApiResultCodes.ValidationError:
        alert(model.ResultMessage);
        break;

      case ApiResultCodes.LockedOut:
        alert(model.ResultMessage);
        break;

      default:
        break;
    }

    fn(model);
  };
}
/**
 * ページを表示します。
 */

export function Page(url, data) {
  Post(url, data, function (data) {
    $("body").html(data);
  });
}